import { Component, Inject, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { trigger, transition, query, style, animate } from '@angular/animations';
import { Observable } from 'rxjs/Observable';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { CommonSerService } from './common-ser.service';
import { HttpClient } from '@angular/common/http';
import { FormControl, Validators } from '@angular/forms';
import { RenderDebugInfo } from '@angular/core/src/render/api';
// import { FileUploader } from 'ng2-file-upload';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('routerAnimation', [
      transition('* <=> *', [
        // Initial state of new route
        query(':enter',
          style({
            position: 'fixed',
            width: '100%',
            transform: 'translateX(-100%)'
          }),
          { optional: true }),
        // move page off screen right on leave
        query(':leave',
          animate('500ms ease',
            style({
              position: 'fixed',
              width: '100%',
              transform: 'translateX(100%)'
            })
          ),
          { optional: true }),
        // move page in screen from left to right
        query(':enter',
          animate('500ms ease',
            style({
              opacity: 1,
              transform: 'translateX(0%)'
            })
          ),
          { optional: true }),
      ])
    ])
  ]
})
export class AppComponent {
  getRouteAnimation(outlet) {
    return outlet.activatedRouteData.animation
  }
}

@Component({
  selector: "upload-document",
  templateUrl: "./uploadDocument.html"
})
export class DocumentUpload implements OnInit {
  fileDocument: File;
  form: any;
  display: string;

  Description = new FormControl('', [Validators.required]);
  @Input() DocumentsData: any = [];
  @Output() DocumentData = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<DocumentUpload>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private common: CommonSerService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    localStorage.removeItem("DocumentsData");
    localStorage.setItem('DocumentsAvailable', 'false');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmitDocument() {
    if (this.fileDocument != undefined && this.Description.value != '') {
      this.display = "block";
      var UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
      this.makeFileRequests(
        this.common.Url + this.common.Url_of_Upload_Document,
        UserValues.EmployeeID,
        UserValues.SessionID,
        this.Description.value,
        this.fileDocument
      ).subscribe(
        res => {
          var SignData: any = [];
          SignData = res;
          if (SignData.success) {
            this.display = "none";
            this.snackBar.open(SignData.extras.Status, null, {
              duration: 3000
            });
            var DocumentData = {
              DocumentID: SignData.extras.DocumentID,
              Url: SignData.extras.DocumentOriginal,
              Name: SignData.extras.Description
            }
            localStorage.setItem("DocumentsData", JSON.stringify(DocumentData));
            localStorage.setItem('DocumentsAvailable', 'true')
            this.dialogRef.close();
          } else {
            this.display = "none";
            this.snackBar.open(
              this.common.ApiMessages[SignData.extras.msg],
              null,
              {
                duration: 3000
              }
            );
          }
        },
        err => {
          this.display = "none";
          alert(JSON.stringify(err));
        }
      );
    } else if (this.fileDocument == undefined || this.Description.value == '') {
      this.snackBar.open(
        'Enter Document Name and Upload any one File',
        null,
        {
          duration: 3000
        }
      );
    }

  }
  onFileChange(event) {
    this.fileDocument = event.target.files[0];
    if (event.target.files[0].size > 5242880) {
      var msg = "Document size should be below 5 MB";
      this.snackBar.open(msg, null, {
        duration: 3000
      });
    } else {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.file = event.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }
  }

  makeFileRequests(url: string, EmployeeID, SessionID, Description, file) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append("EmployeeID", EmployeeID);
      formData.append("SessionID", SessionID);
      formData.append("Description", Description);
      formData.append("file", file);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = event => { };
      xhr.open("POST", url, true);
      xhr.send(formData);
    });
  }

}

@Component({
  selector: 'activity-description',
  templateUrl: './activityDescription.html',
  styleUrls: ['./app.component.css']
})
export class ActivityDescription {
  DocumentsAvailable: boolean;
  DocumentsUrls = [];
  DocumentsData = [];
  TaskStatus; Task_Title;
  Interval_Description_Control = new FormControl('', Validators.required)
  constructor(public dialogRef: MatDialogRef<ActivityDescription>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private common: CommonSerService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog) {
    console.log('constructor eenters')
  }
  ngOnInit() {
    console.log('ngonginte enters')
    var data: any = JSON.parse(localStorage.getItem('TaskData'))
    this.TaskStatus = data.TaskStatus;
    this.Task_Title = data.Task_Title;
    console.log('data ' + JSON.stringify(data));
    console.log('title ' + this.Task_Title);
  }
  onSubmit_Interval_Description() {
    console.log('Interval_Description_Control value ' + this.Interval_Description_Control.value)
    localStorage.setItem('Interval_Description', this.Interval_Description_Control.value)
    if (this.Interval_Description_Control.value != '' && this.Interval_Description_Control.value != null) {
      this.dialogRef.close()
    }
  }
  addDocofActivity() {
    let Activity_Dialog_Ref = this.dialog.open(DocumentUpload, {
      width: "auto",
      data: {}
    });
    Activity_Dialog_Ref.afterClosed().subscribe(result => {
      var bool: any = JSON.parse(localStorage.getItem('DocumentsAvailable'))
      var DocumentsData: any = JSON.parse(localStorage.getItem('DocumentsData'));
      if (bool == true) {
        this.DocumentsData.push(DocumentsData.DocumentID);
        this.DocumentsUrls.push(DocumentsData.Url);
        this.DocumentsAvailable = true;
      } else if (bool == false) {
      }
    });
  }
}

@Component({
  selector: 'forgot-password',
  templateUrl: './forgotPassword.html'
})
export class ForgotPassword {
  EmailIDControl = new FormControl('', [Validators.required, Validators.email]);
  constructor(public dialogRef: MatDialogRef<ForgotPassword>, private common: CommonSerService, private snackBar: MatSnackBar) { }
  getEmailError() {
    return this.EmailIDControl.hasError('required') ? 'Email is required' :
      this.EmailIDControl.hasError('email') ? 'Enter valid email address' : '';
  }
  ngOnInit() { }
  onSubmit() {
    var email = this.EmailIDControl.value
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email != undefined && email != '') {
      if (email.match(pattern)) {
        var valuebody: Object = {
          EmailID: this.EmailIDControl.value
        };
        var forGotPasswordApi = this.common.mrthod(
          this.common.Url_of_Forgot_Password,
          valuebody
        );
        forGotPasswordApi.subscribe(
          res => {
            // Emit list event
            if (res != null) {
              var Responce: any = [];
              Responce = res;
              if (Responce.success) {
                this.snackBar.open(
                  Responce.extras.Status,
                  null,
                  {
                    duration: 3000
                  }
                );
                this.dialogRef.close()
              } else {
                this.snackBar.open(
                  this.common.ApiMessages[Responce.extras.msg],
                  null,
                  {
                    duration: 3000
                  }
                );
              }
            }
          },
          err => {
            alert(JSON.stringify(err));
          }
        );
      } else {
        var msg = 'Enter valid Email address';
        this.snackBar.open(
          msg,
          null,
          {
            duration: 3000
          }
        );
      }
    } else {
      var msg = 'Email is required';
      this.snackBar.open(
        msg,
        null,
        {
          duration: 3000
        }
      );
    }
  }
}

// *************** Update Password ******************

@Component({
  selector: 'update-password',
  templateUrl: './dashboard-emp/updatePassword.html',
})

export class UpdatePassword {
  Password = new FormControl('', [Validators.required]);
  ConfirmPassword = new FormControl('', [Validators.required]);
  getErrorMsgPassword() {
    return this.Password.hasError('required') ? 'Enter Password' :
      this.Password.hasError('minlength') ? 'Password should be Minimum 6 Digits' :
        '';
  }
  getErrorMsgConfirmPassword() {
    return this.ConfirmPassword.hasError('required') ? 'Enter Password' :
      this.ConfirmPassword.hasError('minlength') ? 'Password should be Minimum 6 Digits' :
        '';
  }
  display: string = 'none';
  constructor(
    public dialogRef: MatDialogRef<UpdatePassword>,
    @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, private common: CommonSerService, private snackBar: MatSnackBar) { }
  onUpdatePassword() {
    if (this.Password.value == this.ConfirmPassword.value) {
      this.display = 'block';
      var UserValues: any = JSON.parse(localStorage.getItem('UserValues'))
      const req = this.http.post(this.common.Url + this.common.Url_of_Update_Password, {
        EmployeeID: UserValues.EmployeeID,
        SessionID: UserValues.SessionID,
        Password: this.Password.value
      })
        .subscribe(
          res => {
            var SignData: any = []
            SignData = res
            if (SignData.success) {
              this.display = 'none';
              var messages = 'Password has been Updated';
              this.snackBar.open(messages, null, {
                duration: 3000
              });
              this.dialogRef.close();
            } else {
              this.display = 'none';
              this.snackBar.open(this.common.ApiMessages[SignData.extras.msg], null, {
                duration: 3000
              });
            }
          },
          err => {
            this.display = 'none';
            alert(JSON.stringify(err));
          }
        );
    } else if (this.Password.value != this.ConfirmPassword.value) {
      alert('New Password and Confirm Password should be same');
    }

  }
}

@Component({
  selector: "create-projectDocument",
  templateUrl: "./dashboard-emp/Project/projectDocument.html"
})
export class UpLoadDocument {
  fileDocument: File;
  form: any;
  display: string;

  Description = new FormControl("", [Validators.required]);
  @Input() DocumentsData: any = [];
  @Output() DocumentData = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<UpLoadDocument>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private common: CommonSerService,
    private snackBar: MatSnackBar
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmitDocument() {
    this.display = "block";
    var UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
    this.makeFileRequests(
      this.common.Url + this.common.Url_of_Upload_Document,
      UserValues.EmployeeID,
      UserValues.SessionID,
      this.Description.value,
      this.fileDocument
    ).subscribe(
      res => {
        var SignData: any = [];
        SignData = res;
        if (SignData.success) {
          this.display = "none";
          this.snackBar.open(SignData.extras.Status, null, {
            duration: 3000
          });
          var DocumentData = {
            DocumentID: SignData.extras.DocumentID,
            Url: SignData.extras.DocumentOriginal
          }
          localStorage.setItem("DocumentsData", JSON.stringify(DocumentData));
          localStorage.setItem('DocumentsAvailable', 'true')
          this.dialogRef.close();
        } else {
          this.display = "none";
          this.snackBar.open(
            this.common.ApiMessages[SignData.extras.msg],
            null,
            {
              duration: 3000
            }
          );
        }
      },
      err => {
        this.display = "none";
        alert(JSON.stringify(err));
      }
    );
  }
  onFileChange(event) {
    this.fileDocument = event.target.files[0];
    if (event.target.files[0].size > 5242880) {
      var msg = "Document size should be below 5 MB";
      this.snackBar.open(msg, null, {
        duration: 3000
      });
    } else {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          // this.file = event.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }
  }

  makeFileRequests(url: string, EmployeeID, SessionID, Description, file) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append("EmployeeID", EmployeeID);
      formData.append("SessionID", SessionID);
      formData.append("Description", Description);
      formData.append("file", file);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = event => { };
      xhr.open("POST", url, true);
      xhr.send(formData);
    });
  }
}

// *************** Employee List and Select One ******************
@Component({
  selector: 'employee-list',
  templateUrl: './employeeList.html',
  styles: [`
  th,
td {
  padding: 8px;
}

td {
  border-top: 1px solid #DDD;
}

table {
  width: 100%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.5);
}
  `]
})

export class EmployeeList implements OnInit {
  LOEskip: number = 0;
  LOElimit: number = 2;
  LOEsortOptions = { created_at: -1 };
  LOEp: number = 1;
  LOECount;
  TeamName: any;
  TeamID: any;
  EmployeeID: any;
  empSelectView;
  EmployeeName;
  EMPCount: any;
  EmployeesList = []
  constructor(
    // public uploader:FileUploader = new FileUploader(file);
    public dialogRef: MatDialogRef<EmployeeList>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private common: CommonSerService,
    private snackBar: MatSnackBar
  ) { }
  ngOnInit() {
    var Team: any = JSON.parse(localStorage.getItem('TeamData'));
    this.TeamID = Team.TeamID
    this.TeamName = Team.TeamName
    this.listAllEmployees()
  }
  listAllEmployees() {
    // this.display = 'block';
    var SECRETCODE = localStorage.getItem('SECRETCODE_TOOL')
    var valuebody = {
      SECRETCODE: SECRETCODE,
      skip: this.LOEskip,
      limit: this.LOElimit,
      sortOptions: this.LOEsortOptions
    }
    var EmployeesApi = this.common.mrthod(
      this.common.Url_of_List_Only_Employee,
      valuebody
    );
    EmployeesApi.subscribe(
      res => {
        var SignData: any = [];
        SignData = res
        if (SignData.success) {
          // this.display = 'none';
          this.EmployeesList = SignData.extras.Data;
          this.LOECount = SignData.extras.Count;
          // console.log('EmployeesList ' + JSON.stringify(this.EmployeesList));
        } else {
          // this.display = 'none';
          this.snackBar.open(
            this.common.ApiMessages[SignData.extras.msg],
            null,
            {
              duration: 3000
            }
          );
        }
      },
      err => {
        // this.display = 'none';
        alert(JSON.stringify(err));
      }
    )
  }

  pageChangedLOE(event: number) {
    this.LOEp = event;
    var p = this.LOEp - 1;
    let skip_value = p * this.LOElimit
    this.LOEskip = skip_value;
    this.empSelectView = -1;
    this.listAllEmployees()
  }

  selectEmp(value, emp, e) {
    this.EmployeeName = emp.Name;
    this.EmployeeID = emp.EmployeeID;
    this.empSelectView = e;
  }
  confirmAddTeamMember() {
    var SECRETCODE = localStorage.getItem('SECRETCODE_TOOL')
    var valuebody = {
      SECRETCODE: SECRETCODE,
      EmployeeID: this.EmployeeID,
      TeamID: this.TeamID
    }
    var EmployeeAddTeamApi = this.common.mrthod(
      this.common.Url_of_Add_Employee_Team,
      valuebody
    );
    EmployeeAddTeamApi.subscribe(
      res => {
        var SignData: any = [];
        SignData = res
        if (SignData.success) {
          // this.display = 'none';
          this.dialogRef.close()
        } else {
          // this.display = 'none';
          this.snackBar.open(
            this.common.ApiMessages[SignData.extras.msg],
            null,
            {
              duration: 3000
            }
          );
        }
      },
      err => {
        // this.display = 'none';
        alert(JSON.stringify(err));
      }
    )
  }
}

@Component({
  selector: "create-new-project",
  templateUrl: "./createNewProject.html",
  styles: [`
  .headerStyleCustom {
  padding-bottom: 0px;
  font-family: AvenirNext;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
  }
  .imageUploadStyle {
    background-color: #f6faff;
    cursor: pointer;
    width: 100%;
    height: 130px;
    // padding-top: 50px;
    border-radius: 3px;
    border: 2px dotted #c8d2e3;
    color: #8a9dbf;
  }
  .paddingImageUploadView {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .removeImageStyle {
    float: right;
  }
  .removeImageStyle:hover {
    color: #F00;
    cursor: pointer;
  }
  .paddingCustomTD {
    padding: 0px;
    border-top: none;
  }
  mat-icon:hover {
    cursor: pointer;
  }
  .docuURLNameStyle {
    background-color: #f5f5f5;
    color: #4285f4;
    padding: 5px 15px;
    margin: 8px 0px;
    text-align: left;
    border-radius: 5px;
  }
  .close_button{
    float:right;
    cursor: pointer;
    color: #9b9b9b;
    font-size: 20px;
  }
  .close_button:hover{
    float:right;
    cursor: pointer;
    color:red;
    // font-size: 30px;
  }
  .close_back{
    float:left;
    cursor: pointer;
    color: #9b9b9b;
    font-size: 20px;
  }
  .close_back:hover{
    float:left;
    cursor: pointer;
    color:#4285f4;
    // font-size: 28px;
  }
  .mat-progress-bar {
    display: block;
    height: 2px;
    overflow: hidden;
    position: relative;
    transition: opacity 250ms linear;
    width: 94%;
    margin-left: 14px;
    margin-bottom: 25px;
}
.Uploading {
  font-family: AvenirNext;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-top:30px;
  margin-bottom: 20px;
}
.img-rounded{
  border-radius: 6px;
  background-color: #e6effe;
  width: 25px;
  padding: 10px;
}
  `]
})
export class CreateProject {
Upload_Image = "../assets/img/upload-images.png"
images_upload_success: boolean = false;
  first_form: boolean = true;
  secound_form: boolean = false;
  third_form: boolean = false;
  ImageID: any;
  DocumentsAvailable: boolean = false;
  DocumentsUrls = [];
  DocumentsData = [];
  notUploaded: boolean = true;
  file3: File;
  mobile: File;
  display: string;
  // ProjectNumber = new FormControl('', [Validators.required]);
  ProjectName = new FormControl('', [Validators.required]);
  Project_Description = new FormControl('', [Validators.required]);
  Description = new FormControl('', [Validators.required]);
  file3_name: any;
  file3_size: number;
  fileEvent_doc: File;
  fileDocument: File;
  fileDocument_name: any;
  fileDocument_size: number;
  Documents_data: any [] = [];
  Upload_Persengtage: number = 0;

  constructor(
    public dialogRef: MatDialogRef<CreateProject>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private common: CommonSerService,
    private snackBar: MatSnackBar, public dialog: MatDialog
  ) { }
  // getPNumberError() {
  //   return this.ProjectNumber.hasError('required') ? 'Project Number is required' : '';
  // }
  getPNameError() {
    return this.ProjectName.hasError('required') ? 'Project Name is required' : '';
  }
  getPDescriptionError() {
    return this.Project_Description.hasError('required') ? 'Project Description is required' : '';
  }
  uploadFile(event: any) {
    this.file3 = event.target.files[0];
    this.file3_name = event.target.files[0].name;
    this.file3_size = event.target.files[0].size/(1024*1024);
    console.log("this.file3" , this.file3)

    if (event.target.files[0].size > 1638400) {
      this.snackBar.open(
        'Image size should be below 2 MB',
        null,
        {
          duration: 3000
        }
      )
    } else {
      this.notUploaded = false;
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.mobile = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
      }
      this.uploadImageAPI()
    }
  }
  uploadImageAPI() {
    var UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
    var valuebody: object = {
      EmployeeID: UserValues.EmployeeID,
      SessionID: UserValues.SessionID,
      file: this.file3
    };
    this.makeFileRequests(this.common.Url + this.common.Url_of_Upload_Image, this.file3)
      .subscribe(
        res => {
          var Modules: any = [];
          Modules = res;
          if (Modules.success) {
            this.display = "none";
            this.snackBar.open(Modules.extras.Status, null, {
              duration: 3000
            });
            this.ImageID = Modules.extras.ImageID
            this.images_upload_success = true
          } else {
            this.display = "none";
            this.snackBar.open(
              this.common.ApiMessages[Modules.extras.msg],
              null,
              {
                duration: 3000
              }
            );
          }
        },
        err => {
          this.display = "none";
          alert(JSON.stringify(err));
        }
      )
  }
  makeFileRequests(url: string, file) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append('file', file);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();

          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = (event) => {
      };
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }
  removeImageFile() {
    this.images_upload_success = false;
  }
  uploadDocProj() {
    if (this.DocumentsData.length == 2) {
      let msg = "You can add Maximum 2 Documents";
      this.snackBar.open(msg, null, {
        duration: 3000,
      });
    } else if (this.DocumentsData.length != 2) {
      let dialogRef = this.dialog.open(DocumentUpload, {
        width: "auto",
        data: {}
      });
      dialogRef.afterClosed().subscribe(result => {
        var bool: any = JSON.parse(localStorage.getItem("DocumentsAvailable"));
        var DocumentsData: any = JSON.parse(
          localStorage.getItem("DocumentsData")
        );
        if (bool == true) {
          this.DocumentsData.push(DocumentsData.DocumentID);
          this.DocumentsUrls.push({
            Url: DocumentsData.Url,
            Name: DocumentsData.Name
          });
          this.DocumentsAvailable = true;
        } else if (bool == false) {
        }
      });
    }
  }

  removeDoc(DOCI) {
    this.DocumentsUrls.splice(DOCI, 1)
  }
  createProject_form_first() {
    
    this.ProjectName = this.ProjectName.value
    this.Project_Description = this.Project_Description.value
    console.log("this.ProjectName.value" + this.ProjectName)
    console.log("this.Project_Description.value" + this.Project_Description)
    this.first_form = false;
    this.secound_form = true;
    this.third_form = false
  }
  createProject_form_secound(){
    this.first_form = false;
    this.secound_form = false
    this.third_form = true
    this.ImageID = this.ImageID
    console.log("this.ImageID"+this.ImageID)
  }
  close_popup(){
    this.dialogRef.close();
  }
  back_popup(){
    this.first_form = true;
    this.secound_form = false
    this.third_form = false
  }
  back_popup_1(){
    this.first_form = false;
    this.secound_form = true;
    this.third_form = false
  }

  fileEvent(event: any) {
    this.fileDocument = event.target.files[0];
    this.fileDocument_name = event.target.files[0].name;
    this.fileDocument_size = event.target.files[0].size/(1024*1024);
    // this.mobile = event.target.result;
    console.log("this.mobile ---->" ,this.mobile)
    console.log("this.fileDocument" ,this.fileDocument)
    if (event.target.files[0].size > 5242880) {
      var msg = "Document size should be below 5 MB";
      this.snackBar.open(msg, null, {
        duration: 3000
      });
    } else {
      if (event.target.files && event.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.mobile = event.target.result;
          console.log("this.mobile" ,this.mobile)
        };
        reader.readAsDataURL(event.target.files[0]);
        
      }
      let obj = {
        fileDocument: this.fileDocument,
        fileDocument_name: this.fileDocument_name,
        fileDocument_size: this.fileDocument_size,
        image: this.mobile,
        Description : "",
        Upload_Persengtage: this.Upload_Persengtage
       }

      this.Documents_data.push(obj)
      console.log("Documents_data --->",this.Documents_data)
    }
    
  }

//   click_right(event){
//  this.Description =  this.Description.value
//  if(this.Description == event){
//   this.onSubmitDocument()
//  }
//  this.onSubmitDocument()
// }
  

  makeFileRequests_1(url: string, EmployeeID, SessionID, file, Description) {
    return Observable.create(observer => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append("EmployeeID", EmployeeID);
      formData.append("SessionID", SessionID);
      formData.append("file", file);
      formData.append("Description", Description);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.upload.onprogress = event => { };
      xhr.open("POST", url, true);
      xhr.send(formData);
    });
  }


  onSubmitDocument(doc) {
  
    this.fileDocument = doc.fileDocument
    if (this.fileDocument != undefined) {
      this.display = "block";
      var UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
      this.makeFileRequests_1(
        this.common.Url + this.common.Url_of_Upload_Document,
        UserValues.EmployeeID,
        UserValues.SessionID,
        this.fileDocument,
        doc.Description,
        
      ).subscribe(
        res => {
          var SignData: any = [];
          SignData = res;
          if (SignData.success) {
            this.display = "none";
            this.snackBar.open(SignData.extras.Status, null, {
              duration: 3000
            });
            
            var DocumentData = {
              DocumentID: SignData.extras.DocumentID,
              Url: SignData.extras.DocumentOriginal,
              Name: SignData.extras.Description
            }
            localStorage.setItem("DocumentsData", JSON.stringify(DocumentData));
            localStorage.setItem('DocumentsAvailable', 'true')
            // this.dialogRef.close();
            this.Upload_Persengtage = doc.Upload_Persengtage+10
            console.log("doc.Upload_Persengtage" +doc.Upload_Persengtage)
          } else {
            this.display = "none";
            this.snackBar.open(
              this.common.ApiMessages[SignData.extras.msg],
              null,
              {
                duration: 3000
              }
            );
          }
        },
        err => {
          this.display = "none";
          alert(JSON.stringify(err));
        }
      );
    } else if (this.fileDocument == undefined) {
      this.snackBar.open(
        'Enter Document Name and Upload any one File',
        null,
        {
          duration: 3000
        }
      );
    }

  }


//   createProject() {
//     if (this.notUploaded == false) {
//       var UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
//       var valuebody: object = {
//         EmployeeID: UserValues.EmployeeID,
//         SessionID: UserValues.SessionID,
//         ProjectName: this.ProjectName,
//         Project_Description: this.Project_Description,
//         ImageID: this.ImageID,
//         DocumentsAvailable: this.DocumentsAvailable,
//         DocumentsData: this.DocumentsData
//       };
//       var projectCreateAPI = this.common.mrthod(
//         this.common.Url_of_Create_Project_with_Detailed_Information,
//         valuebody
//       );
//       projectCreateAPI.subscribe(
//         res => {
//           var Modules: any = [];
//           Modules = res;
//           if (Modules.success) {
//             this.display = "none";
//             this.snackBar.open(Modules.extras.Status, null, {
//               duration: 3000
//             });
//             this.ProjectName.reset();
//             this.Project_Description.reset();
//             this.DocumentsAvailable = false;
//             this.DocumentsData = [];
//             this.DocumentsUrls = [];
//             localStorage.setItem('DocumentsAvailable', 'false')
//             localStorage.removeItem('DocumentsData')
//             this.dialogRef.close()
//             this.third_form = false
//           } else {
//             this.display = "none";
//             this.snackBar.open(
//               this.common.ApiMessages[Modules.extras.msg],
//               null,
//               {
//                 duration: 3000
//               }
//             );
//           }
//         },
//         err => {
//           this.display = "none";
//           alert(JSON.stringify(err));
//         }
//       )
//     } else if (this.notUploaded == true) {
//       this.snackBar.open(
//         'Project Image not uploaded',
//         null,
//         {
//           duration: 3000
//         }
//       );
//     }

//   }
}

@Component({
  selector: "interview-status",
  templateUrl: "./interviewStatus.html",
  styles: [`
  .headerStyleCustom {
      border-bottom: 1px solid #DDD;
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: 400;
    }
    .bgColorWhite {
      background-color: #FFF;
    }
    
    .shadowStyleTable {
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
      border: none;
    }
    .formFieldWidth {
      width: 320px;
    }
  `]
})
export class InterviewStatus implements OnInit {
  DateTime: Date;
  Comments = new FormControl('', [Validators.required]);
  Location = new FormControl('', [Validators.required]);
  display: string = 'none';
  InterviewID: any;
  Interview_Status: any;
  finalTime: any;
  constructor(private common: CommonSerService, private snackBar: MatSnackBar, private dialogRef: MatDialogRef<InterviewStatus>) {
    let interview = JSON.parse(localStorage.getItem('Interview'))
    let type = localStorage.getItem('APIType')
    this.InterviewID = interview.InterviewID
    this.Interview_Status = type
  }
  ngOnInit() { }
  onDateSelect(date) {
    this.DateTime = date;
    let month = this.DateTime.getMonth() + 1
    // let dsss = new Date(this.DateTime);
    this.finalTime = this.DateTime.getDate() + '-' + month + '-' + this.DateTime.getFullYear() + ' ' + this.DateTime.getHours() + ':' + this.DateTime.getMinutes() + ':' + this.DateTime.getSeconds()
  }
  submitStatus() {
    this.display = 'block';
    let UserValues: any = JSON.parse(localStorage.getItem("UserValues"));
    let valuesBody;
    let Url;
    if (this.Interview_Status == 1) {
      valuesBody = {
        EmployeeID: UserValues.EmployeeID,
        SessionID: UserValues.SessionID,
        InterviewID: this.InterviewID,
        Comments: this.Comments.value
      }
      Url = this.common.Url_of_Schedule_Interview
    } else if (this.Interview_Status == 2) {
      valuesBody = {
        EmployeeID: UserValues.EmployeeID,
        SessionID: UserValues.SessionID,
        InterviewID: this.InterviewID,
        Comments: this.Comments.value,
        Location: this.Location.value,
        Date_Time: this.finalTime
      }
      Url = this.common.Url_of_Postponed_Rescheduled_Interview
    } else if (this.Interview_Status == 3) {
      valuesBody = {
        EmployeeID: UserValues.EmployeeID,
        SessionID: UserValues.SessionID,
        InterviewID: this.InterviewID,
        Comments: this.Comments.value
      }
      Url = this.common.Url_of_Progress_or_Start_Interview
    }

    var API_REQUEST = this.common.mrthod(Url, valuesBody)
    API_REQUEST.subscribe(
      res => {
        var SignData: any = [];
        SignData = res
        if (SignData.success) {
          this.display = 'none';
          this.snackBar.open(
            SignData.extras.Status,
            null,
            {
              duration: 3000
            }
          );
          this.dialogRef.close()
        } else {
          this.display = 'none';
          this.snackBar.open(
            this.common.ApiMessages[SignData.extras.msg],
            null,
            {
              duration: 3000
            }
          );
        }
      },
      err => {
        this.display = 'none';
        alert(JSON.stringify(err));
      }
    );
  }
}

@Component({
  selector: 'event-description',
  templateUrl: './Dashboard/manage-events/description.html',
  styles: [`
  .headerStyleCustom {
      border-bottom: 1px solid #DDD;
      padding-bottom: 5px;
      font-size: 14px;
      font-weight: 400;
    }
  `]
})

export class DescriptionDialog implements OnInit {
  Description: any;
  constructor() {
    this.Description = localStorage.getItem('Description')
  }
  ngOnInit() { }
}


// WEBPACK FOOTER //
// D:/Venkat Projects/sagiam-tool-angular/src/app/app.component.ts